import React from 'react'
import './Home.css';
// import home_bg from '../images/home_bg.png';

function Home() {
  return (
    <div className='container' id='home'>
        <div className="quote_container">
          <h1 className='h1'>“ Don’t be afraid to get lost. </h1>
          <h1 className='h1'>Every journey begins with a single block. ”</h1>
          <br />
          <br />
          <br />
          <br />
          <h1 className="h2">"Piece by Piece,</h1>
          <h1 className="h2">It will all make sense..."</h1>
        </div>
    </div>
  )
}

export default Home
